import * as singleSpa from "single-spa";
import { matchingPathname, runScript } from "./util";

declare global {
    interface Window { dashboard: any; }
}

window.dashboard = window.dashboard || {};

const loadDashboardApp = async () => {
    await runScript('http://support.meritech.jp:9100/main.js');
    return window.dashboard;
};

export const registerDashboardApp = () => {
    singleSpa.registerApplication(
        'dashboard',
        loadDashboardApp,
        matchingPathname(['/dashboard/main']), // This will be visible on these two routes
        { isHashRouter: false },
    );
};